import { Injectable, signal } from '@angular/core';
import { ItemModel } from '../../interfaces/items.interface';

@Injectable({
  providedIn: 'root',
})
export class ItemSignalService {
  item = signal<ItemModel | undefined>(undefined);

  setItem(item: ItemModel) {
    this.item.set(item);
  }

  getItem(): ItemModel | undefined {
    return this.item();
  }


}
